(() => {
  'use strict';

  if (window.__IBLocalizationCountryLanguage) return;
  window.__IBLocalizationCountryLanguage = true;

  const preferredLocaleByCountry = {
    ES: 'es', FR: 'fr', PT: 'pt-PT', DE: 'de', AT: 'de', IT: 'it', NL: 'nl', BR: 'pt-PT',
    MX: 'es', AR: 'es', CL: 'es', CO: 'es', PE: 'es', GT: 'es', NI: 'es', EC: 'es', BO: 'es',
    UY: 'es', PY: 'es', HN: 'es', PA: 'es', CR: 'es', DO: 'es', AD: 'es',
    GB: 'en', US: 'en', IN: 'en', IE: 'en', NO: 'en', SE: 'en', DK: 'en', FI: 'en', PL: 'en',
    CZ: 'en', AL: 'en', BG: 'en', EE: 'en', GR: 'en', HR: 'en', HU: 'en', LT: 'en', LV: 'en',
    RO: 'en', SI: 'en', SK: 'en', IS: 'en', BA: 'en', XK: 'en', MK: 'en', RS: 'en', MT: 'en', CY: 'en',
    LI: 'de'
  };

  const multilingualLocales = {
    BE: ['nl', 'fr', 'de'],
    CH: ['de', 'fr', 'it'],
    LU: ['fr', 'de'],
    CA: ['en', 'fr']
  };

  const multilingualDefaultLocale = {
    BE: 'nl',
    CH: 'de',
    LU: 'fr',
    CA: 'en'
  };

  const preferredLocale = (countryCode, currentLocale) => {
    const code = String(countryCode || '').toUpperCase();
    const current = String(currentLocale || '').toLowerCase();
    const currentBase = current.split('-')[0];
    const localOptions = multilingualLocales[code];
    if (localOptions) {
      return localOptions.includes(currentBase)
        ? currentLocale
        : (multilingualDefaultLocale[code] || 'en');
    }
    return preferredLocaleByCountry[code] || currentLocale || 'en';
  };

  const prepareLanguage = (component, countryCode) => {
    if (!(component instanceof Element)) return;
    const languageInput = component.querySelector('[ref="languageInput"]');
    if (!(languageInput instanceof HTMLSelectElement)) return;

    const preferred = preferredLocale(countryCode, languageInput.value);
    if (!preferred) return;

    let option = Array.from(languageInput.options).find(
      (item) => item.value.toLowerCase() === String(preferred).toLowerCase()
    );
    if (!option) {
      option = new Option(String(preferred), String(preferred));
      option.hidden = true;
      languageInput.add(option);
    }
    languageInput.value = option.value;
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const item = event.target.closest('localization-form-component [data-value]');
      const component = item?.closest('localization-form-component');
      if (item && component) prepareLanguage(component, item.dataset.value);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' || !(event.target instanceof Element)) return;
      const component = event.target.closest('localization-form-component');
      if (!component) return;
      const item = component.querySelector('[data-value][aria-selected="true"]');
      if (item instanceof HTMLElement) prepareLanguage(component, item.dataset.value);
    },
    true
  );
})();
